import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function Tag(props:any) {
  return (
    <SvgIcon {...props}>
      <path d="M10 4H4a2 2 0 0 0-2 2v6a2 2 0 0 0 .59 1.41l6 6A2 2 0 0 0 10 20h6a2 2 0 0 0 2-2v-6l-8-8z" />
    </SvgIcon>
  )
}
